<router-outlet />

<!-- Velo de carga: UNA sola instancia, gobernada por `OverlayCargaService`.
     Cubre los momentos en que la aplicacion se esta YENDO —entrar a una
     aplicacion, cerrar sesion—, que es cuando la pantalla se queda igual y no
     hay forma de saber si se registro el clic. -->
<intelishs-overlay-carga />
